import { all, fork, AllEffect, ForkEffect } from 'redux-saga/effects';
import authSagas from './auth/authSaga';
import userSagas from './user/userSaga';
import generalSagas from './general/generalSaga';
import subscriptionSagas from './subscription/subscriptionSaga';
import gemSagas from './gem/gemSaga';
import organizationSagas from './organization/organizationSaga';
import paymentSagas from './payment/paymentSaga';
import invoiceSagas from './invoice/invoiceSaga';
import subordinateSagas from './subordinate/subordinateSaga';
import inviteSagas from './invite/inviteSaga';
import modelSagas from './models/modelsSaga';
import websocketSagas from './webSocket/webSocketSaga';
import gemGPTSagas from './gemGPT/gemGPTsaga';

export default function* rootSaga(): Generator<AllEffect<ForkEffect<void>>, void, unknown> {
  yield all([
    fork(authSagas),
    fork(userSagas),
    fork(generalSagas),
    fork(subscriptionSagas),
    fork(gemSagas),
    fork(organizationSagas),
    fork(paymentSagas),
    fork(invoiceSagas),
    fork(subordinateSagas),
    fork(inviteSagas),
    fork(modelSagas),
    fork(websocketSagas),
    fork(gemGPTSagas),
  ]);
}
